<template lang="pug">
v-card-text
  v-row
    v-col(cols='12')
      v-select(
        :value="item.meeting_room"
        :items="locations"
        @input="update('meeting_room', $event)"
        item-text="textToShow"
        item-value="id"
        label="Meeting room"
        :error="formErrors.hasError('meeting_room')"
        :error-messages="formErrors.fields.meeting_room"
      )
    v-col(cols='4')
      v-select(
        :value="item.cbr_location"
        @input="update('cbr_location', $event)"
        :items="crmExamLocation"
        item-text="name"
        item-v
        label="Cbr Location"
        :error="formErrors.hasError('cbr_location')"
        :error-messages="formErrors.fields.cbr_location"
      )
    v-col(cols='4')
      a(:href="item.route_link" target="_blank")
        v-text-field(
          :value="item.route_from"
          label="Route from"
          readonly
          v-if="!editable"
        )
    v-col(cols='4')
      v-text-field(
        v-if="!editable"
        :value="item.postal_code"
        item-text="name"
        item-value="id"
        label="Postal code"
        disabled
      )
    v-col(cols='6')
      v-text-field(
        :value="item.name"
        @input="update('name', $event)"
        label="Name"
        :error="formErrors.hasError('name')"
        :error-messages="formErrors.fields.name"
      )
    v-col(cols='6')
      v-select(
        :value="item.transport_type"
        :items="TRANSPORT_TYPE"
        @input="update('transport_type', $event)"
        label="Transport type"
        :error="formErrors.hasError('transport_type')"
        :error-messages="formErrors.fields.transport_type"
      )
    v-col(cols='3')
      timepicker(
        :value="item.gather_time"
        @input="update('gather_time', $event)"
        label="Gather time"
        :error="formErrors.hasError('gather_time')"
        :error-messages="formErrors.fields.gather_time"
      )
    v-col(cols='3')
      timepicker(
        :value="item.course_start_time"
        @input="update('course_start_time', $event)"
        label="Start time"
        :error="formErrors.hasError('course_start_time')"
        :error-messages="formErrors.fields.course_start_time"
      )
    v-col(cols='3')
      timepicker(
        :value="item.course_end_time"
        @input="update('course_end_time', $event)"
        label="End time"
        :error="formErrors.hasError('course_end_time')"
        :error-messages="formErrors.fields.course_end_time"
      )
    v-col(cols='3')
      timepicker(
        :value="item.exam_time"
        @input="update('exam_time', $event)"
        label="Exam time"
        :error="formErrors.hasError('exam_time')"
        :error-messages="formErrors.fields.exam_time"
      )
    v-col(cols='12')
      span(
        @click="toggleTwoDayCourse"
      )
        v-switch(
          v-model="twoDayCourse"
          readonly
          label="Two days course"
          color="primary"
          hide-details
        )
    template(v-if="twoDayCourse")
      v-col(cols='4')
        v-text-field(
          :value="item.first_day_course_date"
          @input="update('first_day_course_date', $event)"
          label="First day course date"
          :error="formErrors.hasError('first_day_course_date')"
          :error-messages="formErrors.fields.first_day_course_date"
        )

      v-col(cols='4')
        timepicker(
          :value="item.first_day_course_start_time"
          @input="update('first_day_course_start_time', $event)"
          label="First day course start time"
          :error="formErrors.hasError('first_day_course_start_time')"
          :error-messages="formErrors.fields.first_day_course_start_time"
        )
      v-col(cols='4')
        timepicker(
          :value="item.first_day_course_end_time"
          @input="update('first_day_course_end_time', $event)"
          label="First day course end time"
          :error="formErrors.hasError('first_day_course_end_time')"
          :error-messages="formErrors.fields.first_day_course_end_time"
        )
    v-col(cols='12')
      span(
        @click="update('is_independent_exam', !item.is_independent_exam)"
      )
        v-switch(
          v-model="item.is_independent_exam"
          readonly
          label="Zelf examen"
          color="primary"
          hide-details
        )
</template>

<script>
import {mapGetters, mapActions} from "vuex"
import { TRANSPORT_TYPE_LIST } from '../../core/cm-const'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    formErrors: Object,
    needToReset: Boolean,
    editable: Boolean,
    locations: null
  },

  data: () => ({
    TRANSPORT_TYPE: TRANSPORT_TYPE_LIST,
    twoDayCourse: false
  }),

  computed: {
    ...mapGetters({
      crmExamLocation: 'crmExamLocation/items'
    }),

    
  },

  mounted() {
    if(this.item.first_day_course_date) this.twoDayCourse = true
    this.loadExamLocation({cache: true})
  },

  methods: {
    ...mapActions({
      loadExamLocation: 'crmExamLocation/list'
    }),

    update(field, value) {
      this.$emit(`update:${field}`, value)
    },

    toggleTwoDayCourse() {
      this.twoDayCourse = !this.twoDayCourse
      if(!this.twoDayCourse) {
        this.update('first_day_course_date', null)
        this.update('first_day_course_start_time', null)
        this.update('first_day_course_end_time', null)
      }
    }
  },

  watch: {
    needToReset(isReset) {
      if(isReset) {
        if(!this.item.first_day_course_date) this.twoDayCourse = false
        else this.twoDayCourse = true
      }
    }
  },

  components: {
    timepicker: () => import('@/components/global/Timepicker.vue')
  }
}
</script>